import { ref } from "vue";

const counted_selected = ref([])

export{
    counted_selected
}